import { getConfig } from "@/lib/config";
import type { PowerProfilePdfPayload } from "@/lib/power-profile-pdf-model";

export type PowerProfileRendererRequest =
  | { type: "power-profile-render"; payload: PowerProfilePdfPayload }
  | { type: "power-profile-download"; payload: PowerProfilePdfPayload };

export type PowerProfileRendererResponse =
  | { type: "power-profile-renderer-ready" }
  | { type: "power-profile-download-failed" };

export function powerProfileRendererDocumentUrl(): string {
  const basePath = getConfig().basePath;
  return `${basePath.endsWith("/") ? basePath : `${basePath}/`}power-profile-renderer.html`;
}

export function isPowerProfileRendererRequest(data: unknown): data is PowerProfileRendererRequest {
  if (typeof data !== "object" || data === null || !("type" in data)) return false;
  const type = (data as { type: unknown }).type;
  return type === "power-profile-render" || type === "power-profile-download";
}

export function isPowerProfileRendererResponse(data: unknown): data is PowerProfileRendererResponse {
  if (typeof data !== "object" || data === null || !("type" in data)) return false;
  const type = (data as { type: unknown }).type;
  return type === "power-profile-renderer-ready" || type === "power-profile-download-failed";
}
